import AnimatedCounter from '../ui/AnimatedCounter';
import { Stagger, StaggerItem } from '../ui/Reveal';
import { stats } from '../../data/stats';

/** Brand-gradient social-proof band with animated counters. */
const StatsBand = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-brand-700 via-brand-800 to-slate-900 py-16">
      <div className="absolute inset-0 bg-grid-slate opacity-30" aria-hidden="true" />
      <div className="container-tight relative">
        <Stagger className="grid grid-cols-2 gap-8 md:grid-cols-4" stagger={0.1}>
          {stats.map((stat) => {
            const Icon = stat.icon;
            return (
              <StaggerItem key={stat.label} className="text-center">
                <Icon className="mx-auto mb-3 h-7 w-7 text-accent-400" aria-hidden="true" />
                <div className="text-4xl font-bold text-white">
                  <AnimatedCounter value={stat.number} />
                </div>
                <div className="mt-1 text-sm text-brand-100">{stat.label}</div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};

export default StatsBand;
